
import { Vue } from "vue-class-component";

export default class TheBackdrop extends Vue {
  closeSidebar() {
    const sidebar = document.querySelector(".mobile-nav") as HTMLDivElement;
    const backdrop = document.querySelector("#backdrop") as HTMLDivElement;
    backdrop.style.display = "none";
    sidebar.classList.remove("open");
  }
}
